import React from "react";
import "./loginregister.css";
import { useState } from "react";
import axios from "axios";
import Image1 from "../../assets/images/register_page_image.png";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../../Constants";
function Register() {
  const [inputfields, setInputfields] = useState({
    name: "",
    email: "",
    phonenumber: "",
    password: "",
    confirmpassword: "",
  });

  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [responseerror, setResponseerror] = useState([]);

  const validateValues = (inputvalues) => {
    let errors = {};
    if (inputvalues.name == "") {
      errors.name = "name is required";
    }
    if (inputvalues.email == "") {
      errors.email = "email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputvalues.email)) {
      errors.email = "please enter a valid email address";
    }
    if (!inputvalues.phonenumber) {
      errors.phonenumber = "Phone number is required";
    } else if (!/^\d{10,11}$/.test(inputvalues.phonenumber)) {
      errors.phonenumber = "Phone number must be 10 or 11 digits";
    }

    if (inputvalues.password == "") {
      errors.password = "password is required";
    }
    if (inputvalues.confirmpassword === "") {
      errors.confirmpassword = "confirm password is required";
    } else if (inputvalues.password !== inputvalues.confirmpassword) {
      errors.confirmpassword = "password does not match";
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationerrors = validateValues(inputfields);
    setErrors(validationerrors);

    if (Object.keys(validationerrors).length === 0) {
      const registerdata = async () => {
        await axios
          .post(apiurl + "register", {
            name: inputfields.name,
            email: inputfields.email,
            phone: inputfields.phonenumber,
            password: inputfields.password,
            password_confirmation: inputfields.confirmpassword,
          })
          .then((res) => {
            toast.success("✓", { autoClose: 2000, className: "custom-toast" });
            navigate("/login");
          })
          .catch((error) => {
            console.log(error);
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              const errors = error.response.data.error;

              // Check if 'errors' is an object or a single string error message
              if (typeof errors === "string") {
                // Directly display the error if it's a string
                toast.error(errors, { autoClose: 2000 });
              } else {
                // Loop through each error field and show a toast for each error
                Object.keys(errors).forEach((key) => {
                  const errorMessages = errors[key]; // This could be an array or a string

                  // If errorMessages is an array, join them. If it's a string, display it directly
                  const errorMessage = Array.isArray(errorMessages)
                    ? errorMessages.join(" ")
                    : errorMessages;

                  toast.error(errorMessage, { autoClose: 2000 }); // Show the error message in the toast
                });
              }
            }
          });
      };
      registerdata();
    }
  };

  const handleChange = (e) => {
    setInputfields({ ...inputfields, [e.target.name]: e.target.value });
  };

  const handlephoneNumberChange = (e) => {
    const { name, value } = e.target;

    if (/^\d*$/.test(value)) {
      setInputfields({
        ...inputfields,
        [name]: value,
      });
    }
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setInputfields({
        ...inputfields,
        [name]: value,
      });
    }
  };

  return (
    <section className="pt-40 pb-40 loginregister_section">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12"></div>
          <div className=" col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <h2 className="text-center">Register</h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    Name <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={inputfields.name}
                    onChange={handleNameChange}
                    className="form-control"
                    placeholder="Enter your Name"
                  />
                  {errors.name ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.name}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Email <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={inputfields.email}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter your Email"
                  />
                  {errors.email ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.email}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Phone Number <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    name="phonenumber"
                    value={inputfields.phonenumber}
                    onChange={handlephoneNumberChange}
                    maxLength={11}
                    className="form-control"
                    placeholder="Enter your Phone Number"
                  />
                  {errors.phonenumber ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.phonenumber}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Password <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="password"
                    name="password"
                    value={inputfields.password}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter your Password"
                  />
                  {errors.password ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.password}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Confirm Password <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="password"
                    name="confirmpassword"
                    value={inputfields.confirmpassword}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter your Confirm Password"
                  />
                  {errors.confirmpassword ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.confirmpassword}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3 text-center">
                  <button className="btn_1_1" type="submit">
                    Submit
                  </button>
                </div>
              </form>
              <p className="text-center mb-0">
                Already have an Account?{" "}
                <Link
                  to="/login"
                  style={{ color: "#76a70e", textDecoration: "none" }}
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Register;
